// @react/hooks/useCalendarTemplate.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { calendarTemplateStore } from '@core/stores';

/**
 * React hook for EventTemplate operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useCalendarTemplate } from '@react/hooks';
 *
 * const EventTemplateList = observer(() => {
 *   const store = useCalendarTemplate();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useCalendarTemplate() {
  return calendarTemplateStore;
}
